




























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import EmployeeForm from './EmployeeForm/EmployeeForm.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'document', 'meta'
    ]),
  },
  components: {
    EmployeeForm
  }
})
export default class EmployeeDetails extends Vue {

  @Prop() params!: any

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;
  public TAB_VIEW_STATISTIC = 2;

  hActiveTab: number | null = null;

  get activeTab() {
    return this.hActiveTab ? this.hActiveTab : (this.isNew ? this.TAB_VIEW_FORM : this.TAB_VIEW_DETAILS);
  }

  set activeTab(value: number) {
    this.hActiveTab = value
  }

  get config() {
    return this.params || this.$route.params
  }

  get isModal() {
    return this.params
  }

  get isNew() {
    return this.config.id == 'new'
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  @Watch('$route.params')
  public loadDocumentData(nV?: any, oV?: any) {
    if(!this.isModal) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    }
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
    } else {
      this.$router.replace({
        name: 'employee-details',
        params: {
          id: documentId
        }
      })
    }
  }

  public goBack() {
    if (!this.params) {
      this.$router.push({ name: 'employee-list' });
    } else {
      this.$router.back();
      this.$emit('close');
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }

}
